import { breakpoints, Col } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const RatingRow = styled.div<{
  hasHover?: boolean;
}>`
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  height: 1.875rem;
  padding: 0 0.5rem;

  transition: all 0.3s ease;

  cursor: pointer;

  &:hover {
    box-shadow: ${({ hasHover }) =>
      hasHover ? '2px 2px 8px rgba(0, 0, 0, 0.16)' : 'none'};
    border-radius: ${({ hasHover }) => (hasHover ? '0.25rem' : '0')};
  }
`;

export const RatingsValue = styled.div`
  min-width: 7.5rem;
  display: flex;
`;

export const ShowLink = styled.div`
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.925rem;
  margin: 1.25rem 0;
`;

export const StyledCol = styled(Col)`
  padding: 0;
`;

export const HeaderAndStarSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    gap: 2.5rem;
    justify-content: center;
    align-items: center;
    margin-top: 1.5rem;
  }
`;
